import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Divider } from '@material-ui/core';
import { helpStyles } from '../Help';
import srcSelectMenu from '../../../img/help/help_select_menu.jpg';
import srcPersonalProfileMenu from '../../../img/help/help_personal_profile_menu.jpg';
import srcPersonalProfileUpdate from '../../../img/help/help_personal_profile_update.jpg';
import srcPersonalProfileView from '../../../img/help/help_personal_profile_view.jpg';
import { InfoBox } from '../../common/InfoBox';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    ...helpStyles,
}));

const HelpPersonalProfile = () => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <InfoBox>
                <p>
                    紹介文を記入して公開状態に設定しておくと、企業・雇用主ユーザーが紹介文を閲覧できるようになり、且つニュージーワークス経由でメールを送れるようになります。
                </p>
                <p>（プロフィールを設定しなくても求人検索・応募は可能です。）</p>
            </InfoBox>
            <Typography variant="body1" className={classes.helpLine}>
                画面右上、メニューをクリックまたはタップします
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcSelectMenu} alt="Select menu" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpLine}>
                メニューから『プロフィール編集』を選択し、編集ページへ移動します。
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcPersonalProfileMenu} alt="Personal profile menu" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpLine}>
                紹介文と希望勤務地を入力した後、画面下にある『変更を保存』ボタンを押して変更内容を保存してください。
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcPersonalProfileUpdate} alt="Personal profile update" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpLine}>
                プロフィール公開をオンにしていると、雇用主アカウントが紹介文を閲覧できるようになり、且つニュージーワークス経由でのメール送信が可能となります。
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcPersonalProfileView} alt="Personal profile view" className={classes.helpImageStyle} />
            </Box>
        </Box>
    )
}

export default HelpPersonalProfile
